import config from "@/config"
import http from "@/utils/request"
export default {
	ExportSalaryTemplate: {
		url: `${config.API_URL}/CiticUserSalary/ExportSalaryTemplate`,
		name: "保存用户信息",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	ImportSalary: {
		url: `${config.API_URL}/CiticUserSalary/ImportSalary`,
		name: "保存用户信息",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	OrgSalary: {
		url: `${config.API_URL}/CiticUserSalary/OrgSalary`,
		name: "提交银行发放",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	UpdateSalaryPan: {
		url: `${config.API_URL}/CiticUserSalary/UpdateSalaryPan`,
		name: "修改银行卡号",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	ImportSalaryUser: {
		url: `${config.API_URL}/CiticUserSalary/ImportSalaryUser`,
		name: "上传门店员工信息",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	BatchAddSalaryUser: {
		url: `${config.API_URL}/CiticUserSalary/BatchAddSalaryUser`,
		name: "批量开户",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	BatchBindCard: {
		url: `${config.API_URL}/CiticUserSalary/BatchBindCard`,
		name: "批量开卡",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	ExportSalaryUserTemplate: {
		url: `${config.API_URL}/CiticUserSalary/ExportSalaryUserTemplate`,
		name: "下载门店员工模板",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	OrgGuarantorBalance: {
		url: `${config.API_URL}/CiticOrgWith/OrgGuarantorBalance`,
		name: "下载门店员工模板",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	UpdateSalaryState: {
		url: `${config.API_URL}/CiticUserSalary/UpdateSalaryState`,
		name: "下载门店员工模板",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	GetSalaryUserByMobile: {
		url: `${config.API_URL}/CiticUserSalary/GetSalaryUserByMobile`,
		name: "根据手机号码获取门店员工信息",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	AddSalaryUser: {
		url: `${config.API_URL}/CiticUserSalary/AddSalaryUser`,
		name: "单个开户",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	GetSalaryBatchCode: {
		url: `${config.API_URL}/CiticUserSalary/GetSalaryBatchCode`,
		name: "工资批次号生成",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	ImportDisableSalaryUser: {
		url: `${config.API_URL}/CiticUserSalary/ImportDisableSalaryUser`,
		name: "导入禁用工资账户",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	ExportDisableSalaryUserTemplate: {
		url: `${config.API_URL}/CiticUserSalary/ExportDisableSalaryUserTemplate`,
		name: "下载禁用工资账户导入模板",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	BatchDeleteSalary: {
		url: `${config.API_URL}/CiticUserSalary/BatchDeleteSalary`,
		name: "批量删除待处理工资记录",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	GetSalaryImportHistory: {
		url: `${config.API_URL}/CiticUserSalary/GetSalaryImportHistory`,
		name: "查询工资导入历史记录",
		post: async function (data) {
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
}
